import { render, staticRenderFns } from "./PerNumber.vue?vue&type=template&id=cb08b288&"
import script from "./PerNumber.vue?vue&type=script&lang=js&"
export * from "./PerNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports